import { useEffect, useRef, useState } from 'react'
import { ResizeObserver } from '@juggle/resize-observer'
import type { BasicTarget } from 'ahooks/lib/utils/dom'
import { getTargetElement } from 'ahooks/lib/utils/dom'

/**
 * 观察dom节点变化，获取dom大小
 * @param id dom节点id
 * @returns
 */
export const useResizeDomRect = (id: string, deps?: string[]) => {
  const [domRect, setDomRect] = useState<ResizeObserverEntry['contentRect']>()
  const ref = useRef<ResizeObserverEntry['contentRect']>()
  useEffect(() => {
    try {
      if (!ResizeObserver) return
      const myObserver = new ResizeObserver((entries) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) {
            return
          }
          const newDomRect = entries[0].contentRect
          // 对比一下依赖
          if (!deps || !deps.length || !ref.current || deps.some((key) => ref.current[key] !== newDomRect[key])) {
            setDomRect(newDomRect)
            ref.current = newDomRect
          }
        })
      })
      let contentEle = document.getElementById(id)
      if (contentEle) {
        myObserver.observe(contentEle)
      } else {
        setTimeout(() => {
          contentEle = document.getElementById(id)
          contentEle && myObserver.observe(contentEle)
        }, 0)
      }
      return () => {
        myObserver.disconnect()
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, deps?.join(',')])

  return domRect
}

export const useResizeObserver = (target: BasicTarget) => {
  const [domRect, setDomRect] = useState<ResizeObserverEntry>()

  useEffect(() => {
    try {
      if (!ResizeObserver) return
      const myObserver = new ResizeObserver((entries) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) {
            return
          }
          setDomRect(entries[0])
        })
      })
      setTimeout(() => {
        const ele = getTargetElement(target)
        if (ele) {
          myObserver.observe(ele as Element)
        }
      }, 0)

      return () => {
        myObserver.disconnect()
      }
    } catch (error) {}
  }, [target])

  return domRect
}
